
function inject (injection) {
    return component => props => component({ ...props, ...injection });
}

export const HighOrderComponent = { inject };
